import RezervacniFormular from "./RezervacniFormular.svelte";

let target = document.querySelector("div#rezervace");


if(target) {
    if(typeof window.RezervacniFormularProps !== "undefined") 
    {
        const form = new RezervacniFormular({
            target: target,
            props: window.RezervacniFormularProps
        });
    }
    else {
        const form = new RezervacniFormular({
            target: target,
            props: {
                kontakty: {
                    telefon : "+420 123 456 789",
                    email: "administrace@hraza.cz"
                },
                rezervacni_mista: [
                    {
                        id: "hraza",
                        nazev: "Hráza",
                    }
                ]
            }
        });
    }

}
else {
    console.log("Došlo k chybě, nelze najít RS_Form prvek v dokumentu.");
}